import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { FlexCenterBetweenWrapper, FlexCenterWrapper, Mr2 } from 'wrappers';
import { PrimaryTextBase, ClickableIcon, Icon } from 'atoms';
import { textEllipsis } from 'utils/ellipsis';
import { EyeSvg, ImageSvg, CloudSvg, PDFDocumentSvg } from 'components/icons';

export const definition = {
  name: 'DownloadFileRow',
  controller: Controller,
  initialProps: ({ fileName, contentType }) => ({ fileName, contentType }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'LeftSide',
      elements: [
        {
          component: wrap(Icon, Mr2),
          name: 'Icon',
          displayValue: ({ contentType }) => contentType?.includes('pdf') ? PDFDocumentSvg({ color: '#1AAA60' }) : ImageSvg({ width: 18, height: 18, color: '#1AAA60' })
        },
        {
          component: PrimaryTextBase,
          name: 'FileName',
          displayValue: ({ fileName }) => textEllipsis(fileName ?? '', 40),
        }
      ]
    },
    {
      wrapper: FlexCenterWrapper,
      name: 'RightSide',
      elements: [
        {
          component: wrap(ClickableIcon, Mr2),
          name: 'View',
          bindings: ({ }) => ({}),
          displayValue: ({ }) => EyeSvg({ width: 20, height: 16, color: '#C2CCCE', notCrossed: true })
        },
        {
          component: wrap(ClickableIcon, Mr2),
          name: 'Download',
          bindings: ({ }) => ({}),
          displayValue: ({ }) => CloudSvg({ width: 24, height: 24, color: '#C2CCCE', download: true })
        },
      ]
    }
  ]
};

export default wrap(ContainerComponent(definition), FlexCenterBetweenWrapper);